import React, { useState } from 'react';
import { register } from '../api';
import { useTheme } from '../ThemeContext';
import { BASE_URL } from '../api';

export default function Register() {
  const { colors, common } = useTheme();
  const [email, setEmail]       = useState('');
  const [password, setPassword] = useState('');
  const [error, setError]       = useState('');
  const [loading, setLoading]   = useState(false);
  const [verified, setVerified] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resendMsg, setResendMsg]         = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) {
      setError('Password must be at least 8 characters.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await register({ email, password });
      setVerified(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Could not create account. Email may already be in use.');
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResendLoading(true);
    setResendMsg('');
    try {
      const res = await fetch(`${BASE_URL}/api/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const data = await res.json();
      setResendMsg(data.message || 'Sent.');
    } catch {
      setResendMsg('Could not resend. Please try again.');
    } finally {
      setResendLoading(false);
    }
  };

  if (verified) {
    return (
      <main style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', backgroundColor: colors.pageBg, padding: 20,
      }}>
        <div style={{
          backgroundColor: colors.cardBg, border: `1px solid ${colors.borderColor}`,
          boxShadow: '0 24px 48px rgba(0,0,0,0.2)', padding: '40px 36px',
          borderRadius: 16, width: '100%', maxWidth: 420, textAlign: 'center',
        }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📧</div>
          <h1 style={{ margin: '0 0 12px', fontSize: 22, fontWeight: 800, color: colors.textPrimary }}>
            Check your email
          </h1>
          <p style={{ margin: '0 0 24px', color: colors.textSecondary, fontSize: 15, lineHeight: 1.6 }}>
            We sent a verification link to <strong style={{ color: colors.textPrimary }}>{email}</strong>.
            Click the link in that email to activate your account.
          </p>
          <p style={{ margin: '0 0 8px', color: colors.textMuted, fontSize: 13 }}>
            Didn't receive it?
          </p>
          <button
            style={{ ...common.btn, ...common.btnPrimary, opacity: resendLoading ? 0.7 : 1 }}
            onClick={handleResend}
            disabled={resendLoading}
          >
            {resendLoading ? 'Sending...' : 'Resend verification email'}
          </button>
          {resendMsg && (
            <p style={{ marginTop: 12, color: colors.successText, fontSize: 13 }}>{resendMsg}</p>
          )}
          <p style={{ marginTop: 24, color: colors.textMuted, fontSize: 14 }}>
            <a href="/login" style={{ color: colors.link, textDecoration: 'none', fontWeight: 600 }}>
              Back to sign in
            </a>
          </p>
        </div>
      </main>
    );
  }

  return (
    <main id="main-content" style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', backgroundColor: colors.pageBg, padding: 20,
    }}>
      <div style={{
        backgroundColor: colors.cardBg, border: `1px solid ${colors.borderColor}`,
        boxShadow: '0 24px 48px rgba(0,0,0,0.2)', padding: '40px 36px',
        borderRadius: 16, width: '100%', maxWidth: 400,
      }}>
        <div style={{
          width: 44, height: 44, borderRadius: 12,
          background: `linear-gradient(135deg, ${colors.indigo}, #7c3aed)`,
          color: colors.white, fontSize: 22, fontWeight: 800,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          marginBottom: 16, boxShadow: `0 4px 12px rgba(79,70,229,0.4)`,
        }}>S</div>

        <h1 style={{ margin: '0 0 4px 0', fontSize: 24, fontWeight: 800, color: colors.textPrimary, letterSpacing: '-0.02em' }}>
          Software Simulation Builder
        </h1>
        <p style={{ margin: '0 0 28px 0', color: colors.textSecondary, fontSize: 14 }}>
          Create your account
        </p>

        {error && <p role="alert" style={common.errorText}>{error}</p>}

        <form onSubmit={handleSubmit}>
          <label htmlFor="register-email" style={common.label}>Email address</label>
          <input id="register-email" style={common.input} type="email" placeholder="you@example.com"
            value={email} onChange={(e) => setEmail(e.target.value)} required autoFocus />
          <label htmlFor="register-password" style={common.label}>Password</label>
          <input id="register-password" style={common.input} type="password" placeholder="Minimum 8 characters"
            value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
          <button
            style={{ ...common.btn, ...common.btnPrimary, width: '100%', justifyContent: 'center', padding: 11, fontSize: 15, marginTop: 4, opacity: loading ? 0.7 : 1 }}
            type="submit" disabled={loading}>
            {loading ? 'Creating account...' : 'Create Account'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 20, color: colors.textMuted, fontSize: 14 }}>
          Already have an account?{' '}
          <a href="/login" style={{ color: colors.link, textDecoration: 'none', fontWeight: 600 }}>Sign in</a>
        </p>
      </div>
    </main>
  );
}
